<template>
    <small v-show="message" class="p-error">{{ message }}</small>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: ['message']
    })
</script>
